import sectionSorter from 'bits/section_sorter'
import { $ } from 'bits/jquery_ui_sortable'

export default {
  data() {
    return {
      $_sectionsOrderSortMixin_initialized: false,
    }
  },
  updated() {
    if (this.$_sectionsOrderSortMixin_initialized) {
      this.$_sectionsOrderSortMixin_makeSortable()
    } else {
      this.$_sectionsOrderSortMixin_destroySortable()
    }
  },
  beforeDestroy() {
    this.$_sectionsOrderSortMixin_destroySortable()
  },
  methods: {
    initializeSectionsOrderSort() {
      this.$_sectionsOrderSortMixin_initialized = true
    },
    $_sectionsOrderSortMixin_markItemAsTransiting(item) {
      item.addClass('noclick in-transit')
    },

    $_sectionsOrderSortMixin_unmarkItemAsTransiting(item) {
      item.removeClass('noclick in-transit')
    },

    $_sectionsOrderSortMixin_makeSortable() {
      let $el = $(this.$el)
      if (!$el.sortable('instance')) {
        $el.sortable({
          axis: 'x',
          cursor: 'move',
          handle: '.surface-section-title',
          items: '> .surface-section.section-sortable',
          scrollSensitivity: 48,
          cancel: '[contenteditable], .ui-resizable-handle, object, embed, input, button, textarea',
          start: (e, ui) => {
            var sectionId
            sectionId = ui.item.data('section-id')
            if (sectionId == null) {
              this.update()
            }
            this.$_sectionsOrderSortMixin_markItemAsTransiting(ui.item)
          },
          stop: (e, ui) => {
            this.$_sectionsOrderSortMixin_unmarkItemAsTransiting(ui.item)
          },
          update: (e, ui) => {
            this.sortedSection(sectionSorter.getNewIndex(ui.item))
          },
        })
      }
    },
    $_sectionsOrderSortMixin_destroySortable: function() {
      let $el = $(this.$el)
        .off('.sort')
        .sortable('instance')
      if (!!$el) {
        $el.destroy()
      }
    },
  },
}

// ---
// generated by coffee-script 1.9.2
